import { render } from "./CardChooserComponent.vue?vue&type=template&id=2c982e50&scoped=true&ts=true"
import script from "./CardChooserComponent.vue?vue&type=script&lang=ts"
export * from "./CardChooserComponent.vue?vue&type=script&lang=ts"

import "./CardChooserComponent.vue?vue&type=style&index=0&id=2c982e50&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c982e50"]])

export default __exports__